import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import course102 from "../data/courses/course102";
import course103 from "../data/courses/course103";
import CourseHeader from "../components/CourseHeader";
import ModuleNavigator from "../components/ModuleNavigator";
import ProgressBar from "../components/ProgressBar";

import "../styles/CourseStudy.css";

const courses = [course102, course103];

const CourseStudy = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const course = courses.find((c) => c.id === id);

  const [moduleIndex, setModuleIndex] = useState(0);
  const [sectionIndex, setSectionIndex] = useState(0);

  if (!course) {
    return (
      <div className="course-page">
        <h2>Course not found</h2>
      </div>
    );
  }
  const currentModule = course.modules[moduleIndex];
  if (!currentModule) return <div>Module not found</div>;

  const currentSection = currentModule.sections?.[sectionIndex];

  if (!currentSection) return <div>Section not found</div>;

  const totalSections = course.modules.reduce(
    (total, module) => total + module.sections.length,
    0
  );

  const getCurrentProgress = () => {
    let count = 0;

    for (let i = 0; i < moduleIndex; i++) {
      count += course.modules[i].sections.length;
    }

    return count + sectionIndex + 1;
  };

  const currentProgress = getCurrentProgress();

  useEffect(() => {
    localStorage.setItem(
      `course-${id}-progress`,
      JSON.stringify({
        moduleIndex,
        sectionIndex,
      })
    );
  }, [moduleIndex, sectionIndex, id]);

  const nextSection = () => {
    const isLastSectionInCourse =
      moduleIndex === course.modules.length - 1 &&
      sectionIndex === currentModule.sections.length - 1;

    if (isLastSectionInCourse) {
      navigate("/quiz/section-a");
      return;
    }

    if (sectionIndex < currentModule.sections.length - 1) {
      setSectionIndex(sectionIndex + 1);
    } else if (moduleIndex < course.modules.length - 1) {
      setModuleIndex(moduleIndex + 1);
      setSectionIndex(0);
    }
  };

  const previousSection = () => {
    if (sectionIndex > 0) {
      setSectionIndex(sectionIndex - 1);
    } else if (moduleIndex > 0) {
      const prevModule = course.modules[moduleIndex - 1];

      setModuleIndex(moduleIndex - 1);
      setSectionIndex(prevModule.sections.length - 1);
    }
  };

  const handleModuleSelect = (moduleId: string | number) => {
    const index = course.modules.findIndex((module) => module.id === moduleId);

    if (index !== -1) {
      setModuleIndex(index);
      setSectionIndex(0);
    }
  };

  return (
    <div className="course-page">
      <CourseHeader
        title={course.title}
        // description={course.description}
        totalModules={course.modules.length}
        completedSections={currentProgress}
        totalSections={totalSections}
      />

      <ProgressBar current={currentProgress} total={totalSections} />

      <div className="course-layout">
        <ModuleNavigator
          modules={course.modules}
          activeModuleId={currentModule.id}
          onSelectModule={handleModuleSelect}
        />

        <main className="course-content">
          <span className="section-tag">Module {moduleIndex + 1}</span>

          <h2>{currentSection.title}</h2>
          <div className="section-content"><strong>{currentSection.heading}</strong></div>
          <div className="section-content">{currentSection.content}</div>

          <div className="navigation-buttons">
            <button
              onClick={previousSection}
              disabled={moduleIndex === 0 && sectionIndex === 0}
            >
              Previous
            </button>

            <button onClick={nextSection}>Next</button>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CourseStudy;
